"use strict";

var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ClientSettings = void 0;
var _types = require("../types"),
  _logging = require("../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var ClientSettings = /*#__PURE__*/function () {
  function ClientSettings(a, b) {
    _classCallCheck(this, ClientSettings);
    _defineProperty(this, "updateInterval", void 0), _defineProperty(this, "environment", void 0), _defineProperty(this, "networkDomain", void 0), _defineProperty(this, "requestTimeout", void 0), _defineProperty(this, "siteCode", void 0), _defineProperty(this, "cleanupInterval", void 0), _defineProperty(this, "trackRetryDelay", void 0), _defineProperty(this, "trackingInterval", void 0), _logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: new ClientSettings(siteCode: ", ", configuration: ", ")"])), a, b), this.siteCode = a, this.environment = this.getEnvironment(b), this.networkDomain = this.getNetworkDomain(b), this.updateInterval = this.getUpdateInterval(b), this.cleanupInterval = this.getCleanupInterval(b), this.requestTimeout = this.getRequestTimeout(b), this.trackingInterval = this.getTrackingInterval(b), this.trackRetryDelay = 5 * _types.Milliseconds.Second, _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN: new ClientSettings(siteCode: ", ", configuration: ", ")"])), a, b);
  }
  return _createClass(ClientSettings, [{
    key: "getTrackingInterval",
    value: function getTrackingInterval(a) {
      return "number" == typeof (null === a || void 0 === a ? void 0 : a.trackingInterval) ? 100 > a.trackingInterval ? (_logging.KameleoonLogger.warning("Tracking interval must not be shorter than 100 ms. Minimum possible interval was applied."), 100) : 1e3 < a.trackingInterval ? (_logging.KameleoonLogger.warning("Tracking interval must not be longer than 1000 ms. Maximum possible interval was applied."), 1e3) : a.trackingInterval : 1e3;
    }
  }, {
    key: "getEnvironment",
    value: function getEnvironment(a) {
      return null !== a && void 0 !== a && a.environment ? a.environment : _types.Environment.Production;
    }
  }, {
    key: "getCleanupInterval",
    value: function getCleanupInterval(a) {
      return "number" == typeof (null === a || void 0 === a ? void 0 : a.targetingDataCleanupInterval) ? 1 > a.targetingDataCleanupInterval ? (_logging.KameleoonLogger.warning("Targeting data cleanup interval must not be shorter than 1 minute. Minimum possible interval was applied."), 1 * _types.Milliseconds.Minute) : a.targetingDataCleanupInterval * _types.Milliseconds.Minute : null;
    }
  }, {
    key: "getUpdateInterval",
    value: function getUpdateInterval(a) {
      return "number" == typeof (null === a || void 0 === a ? void 0 : a.updateInterval) ? 1 > a.updateInterval ? (_logging.KameleoonLogger.warning("Update interval must not be shorter than 1 minute. Minimum possible interval was applied."), 1 * _types.Milliseconds.Minute) : a.updateInterval * _types.Milliseconds.Minute : 60 * _types.Milliseconds.Minute;
    }
  }, {
    key: "getNetworkDomain",
    value: function getNetworkDomain(a) {
      if (null !== a && void 0 !== a && a.networkDomain) {
        var b = a.networkDomain.split(".");
        return 2 === b.length ? a.networkDomain : null;
      }
      return null;
    }
  }, {
    key: "getRequestTimeout",
    value: function getRequestTimeout(a) {
      return "number" == typeof (null === a || void 0 === a ? void 0 : a.requestTimeout) ? a.requestTimeout : 10 * _types.Milliseconds.Second;
    }
  }, {
    key: "settings",
    get: function get() {
      return {
        trackingInterval: this.trackingInterval,
        trackRetryDelay: this.trackRetryDelay,
        cleanupInterval: this.cleanupInterval,
        updateInterval: this.updateInterval,
        requestTimeout: this.requestTimeout,
        networkDomain: this.networkDomain,
        environment: this.environment,
        siteCode: this.siteCode
      };
    }
  }]);
}();
exports.ClientSettings = ClientSettings;